import { WorksheetRows } from "../engine/validationTypes";

// A copy of the worksheet without the given file rows, or the sheet itself when none match.
export function buildSheetWithoutRows(sheet: WorksheetRows, rowNumbers: Set<number> | undefined): WorksheetRows {
  if (!rowNumbers || rowNumbers.size === 0) return sheet;
  const keptIndexes = sheet.rowNumbers
    .map((rowNumber, index) => ({ rowNumber, index }))
    .filter((row) => !rowNumbers.has(row.rowNumber));
  if (keptIndexes.length === sheet.rows.length) return sheet;
  return {
    worksheet: sheet.worksheet,
    sourceColumns: sheet.sourceColumns,
    rows: keptIndexes.map((row) => sheet.rows[row.index]),
    rowNumbers: keptIndexes.map((row) => row.rowNumber),
  };
}
